"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = exports.Mark = void 0;
class Mark {
}
exports.Mark = Mark;
class Collection {
}
exports.Collection = Collection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW50aXRpZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYm9va21hcmsvZW50aXRpZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBYSxJQUFJO0NBR2hCO0FBSEQsb0JBR0M7QUFFRCxNQUFhLFVBQVU7Q0FLdEI7QUFMRCxnQ0FLQyJ9